// angular
import {Component, OnInit, inject} from "@angular/core";
import {appRoutes} from "src/app/shared/constants/routes";
import {NgClass} from "@angular/common";
import {RouterLink} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";
// material angular
import {MatDialog} from "@angular/material/dialog";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
// components
import {ReminderDialogComponent} from "@app/core/components/reminder-dialog/reminder-dialog.component";
// services
import {LayoutService} from "../shared/services/layout.service";
// types
import {Role} from "@app/shared/types/role.enum";
// directive
import {HasAccessDirective} from "@app/core/directives/has-access.directive";

@Component({
  selector: "app-quick-access",
  templateUrl: "./quick-access.component.html",
  styleUrls: ["./quick-access.component.scss"],
  standalone: true,
  imports: [
    TranslateModule,
    NgClass,
    MatIconModule,
    RouterLink,
    MatButtonModule,
    HasAccessDirective,
  ],
})
export class QuickAccessComponent implements OnInit {
  public quickAccessIsOpen = false;

  public items = [
    {
      route: `${appRoutes.customers}/create`,
      key: "مشتری جدید",
      icon: "group",
      role: [
        Role.CreateCustomer,
        Role.CreateCustomerSelf,
        Role.CreateCustomerCapillary,
        Role.CreateCustomerCapillarySelf,
      ],
    },
    {
      route: `${appRoutes.orders}/create`,
      key: "سفارش جدید",
      icon: "menu_book",
      role: [
        Role.CreateOrder,
        Role.CreateOrderSelf,
        Role.CreateOrderCapillary,
        Role.CreateOrderCapillarySelf,
      ],
    },
    {
      key: "reminders.create.newReminder",
      icon: "notifications",
      operation: () => this._openReminderDialog(),
      role: [Role.CreateReminder, Role.CreateReminderSelf],
    },
  ];

  // dependencies
  private _layoutService = inject(LayoutService);
  private _dialog = inject(MatDialog);

  constructor() {
    this._layoutService.quickAccessIsOpen$.subscribe((isOpen) => {
      this.quickAccessIsOpen = isOpen;
    });
  }

  ngOnInit(): void {
    const quickAccessMenu = document.getElementById("quick-access-menu");
    const quickAccessArrowBox = document.getElementById(
      "quick-access-arrow-box"
    );

    document.addEventListener("click", (event) => {
      const isOutSide =
        !quickAccessMenu!.contains(event.target as Node) &&
        !quickAccessArrowBox!.contains(event.target as Node);
      if (isOutSide) {
        // this.hideQuickAccess();
      }
    });
  }

  public toggleQuickAccess(itemOperation?: CallableFunction) {
    if (itemOperation) {
      itemOperation();
    }
    this._layoutService.quickAccessIsOpen$.next(!this.quickAccessIsOpen);
  }

  public hideQuickAccess() {
    this.quickAccessIsOpen &&
      this._layoutService.quickAccessIsOpen$.next(false);
  }

  private _openReminderDialog() {
    const dialogRef = this._dialog.open<ReminderDialogComponent>(
      ReminderDialogComponent,
      {
        width: "100%",
        maxWidth: "500px",
      }
    );

    dialogRef.afterClosed().subscribe((data) => {});
  }
}
